/**
 * Converts an ISO date string ("YYYY-MM-DD") to the integer-string
 * Redis sorted-set score format ("YYYYMMDD") used by the API's
 * `ZRANGE users <start> <end> BYSCORE` queries. See CLAUDE.md's
 * "Critical Patterns" section.
 */
export function toRedisScoreDate(dateStr) {
  return dateStr.replace(/-/g, '');
}
